import React from 'react'
import CareersSection from '../../sections/CareersSection'
import { CareersSliceProps } from './types'

const CareersSlice: React.FC<CareersSliceProps> = ({ slice }) => {
  const {
    c_title,
    c_is_main_heading,
    c_container_id,
    c_container_domain,
    c_container_version,
    c_container_department_id,
    c_script_url,
    c_script_async,
    c_script_defer
  } = slice.primary || {}

  return (
    <CareersSection
      heading={c_title?.text}
      isMainHeading={c_is_main_heading}
      headingPadding={['45px', '', '85px']}
      bgColor="#F8FAFF"
      inner="inners.primary"
      paddingTop={['40px', '', '84px']}
      paddingBottom={['40px', '', '80px']}
      data={{
        containerAttrs: {
          id: c_container_id,
          domain: c_container_domain,
          version: c_container_version,
          departmentId: c_container_department_id
        },
        script: {
          async: c_script_async,
          defer: c_script_defer,
          src: c_script_url?.url
        }
      }}
    />
  )
}

export default CareersSlice
